import type {
  ExportSessionResponse,
  Session,
  SessionPatientInsertRequest,
  SessionUpdateRequest,
  SessionsResponse,
} from "types/Session.type";

import { api } from "utils/api";

export const getSessions = () =>
  api.get<SessionsResponse>("/session", {
    additionalParams: { include: ["sessionPatient", "sessionReport"] },
  });

export const getSession = async (id: string) => {
  return await api.get<Session>(`/session/${id}`, {
    additionalParams: {
      include: [
        "sessionPatient",
        "sessionCategories",
        "company",
        "sessionCategories.settingsCategory",
        "sessionReport",
      ],
    },
  });
};

export const createSession = async (session?: SessionPatientInsertRequest) =>
  await api.post<Session>("/session", { sessionPatientInsertRequest: session });

export const cancelSession = (id: string) => api.post<void>(`/session/${id}/cancel`);

export const summarizeSession = async (id: string) => await api.post<Session>(`/session/${id}/summarize`);

export const updateSession = async (id: string, session: SessionUpdateRequest) =>
  await api.put<Session>(`/session/${id}`, { ...session });

export const exportSession = (id: string) =>
  api.post<ExportSessionResponse>(`/session/${id}/download`, undefined, {
    responseType: "blob",
    export: true,
  });

export const continueSession = (id: string) => api.post<Session>(`/session/${id}/rerecord`);

export const transcribeSession = (id: string, data: any) => {
  return api.post(`/session/${id}/transcribe`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadScanedDocument = async (id: string, doc: File | Blob) => {
  const formData = new FormData();
  formData.append("file", doc);
  return await api.post<any>(`/session/${id}/scan`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
